/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BanReason {
    VIOLATED_RULES = 'VIOLATED_RULES',
    PAYMENT_FAILURE = 'PAYMENT_FAILURE',
}
